import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { AdminService } from "../../service/admin.service";
import * as constants from "../../app.constants";

@Component({
  selector: "providers",
  template: require('./providers.component.html'),
  styles: [require('./providers.component.css')],
})
export class ProvidersComponent implements OnInit, OnDestroy {
  @ViewChild("providerModal") public providerModal: ModalComponent;
  @ViewChild("deleteModal") public deleteModal: ModalComponent;
  @ViewChild("uploadsModal") public uploadsModal: ModalComponent;

  providers: any[] = [];
  selectedProvider: any = null;
  uploads: any[] = [];
  showLoader = false;

  nameControl: FormControl;
  passcodeControl: FormControl;
  isActiveControl: FormControl;

  constructor(private adminService: AdminService) {}

  ngOnInit() {
    this.initForm();
    this.loadProviders();
    this.providerModal.onDismiss.subscribe(() => this.resetForm());
    this.deleteModal.onDismiss.subscribe(() => (this.selectedProvider = null));
  }

  ngOnDestroy() {
    this.providerModal.onDismiss.unsubscribe();
    this.deleteModal.onDismiss.unsubscribe();
  }

  private initForm() {
    this.nameControl = new FormControl("", [Validators.required]);
    this.passcodeControl = new FormControl("", [Validators.required]);
    this.isActiveControl = new FormControl(true);
  }

  private resetForm() {
    this.selectedProvider = null;
    this.nameControl.reset("");
    this.passcodeControl.reset("");
    this.isActiveControl.reset(true);
  }

  // --- CRUD ---

  loadProviders() {
    this.showLoader = true;
    this.adminService
      .getCall(constants.URLs.customProviders, true)
      .then((res) => {
        this.showLoader = false;
        this.providers = res.results || res;
      })
      .catch((e) => this.handleError(e));
  }

  openAddModal() {
    this.resetForm();
    this.providerModal.open();
  }

  openEditModal(provider: any) {
    this.selectedProvider = provider;
    this.nameControl.setValue(provider.name);
    this.passcodeControl.setValue(provider.passcode);
    this.isActiveControl.setValue(provider.is_active);
    this.providerModal.open();
  }

  saveProvider() {
    if (!this.nameControl.valid || !this.passcodeControl.valid) return;

    const data = {
      name: this.nameControl.value,
      passcode: this.passcodeControl.value,
      is_active: this.isActiveControl.value,
    };

    this.showLoader = true;
    const promise = this.selectedProvider
      ? this.adminService.patchCall(
          constants.URLs.customProviders + this.selectedProvider.id + "/",
          data,
          true
        )
      : this.adminService.postCall(constants.URLs.customProviders, data, true);

    promise
      .then(() => {
        this.showLoader = false;
        this.providerModal.dismiss();
        this.loadProviders();
        this.adminService.showSuccessToast(constants.messages.dataSaved);
      })
      .catch((e) => this.handleError(e));
  }

  openDeleteModal(provider: any) {
    this.selectedProvider = provider;
    this.deleteModal.open();
  }

  deleteProvider() {
    if (!this.selectedProvider) return;
    this.showLoader = true;
    this.adminService
      .deleteCall(
        constants.URLs.customProviders + this.selectedProvider.id + "/",
        true
      )
      .then(() => {
        this.showLoader = false;
        this.deleteModal.dismiss();
        this.loadProviders();
        this.adminService.showSuccessToast(constants.messages.dataDeleted);
      })
      .catch((e) => this.handleError(e));
  }

  // --- Uploads ---

  openUploadsModal(provider: any) {
    this.selectedProvider = provider;
    this.uploads = [];
    this.showLoader = true;

    this.adminService
      .getCall(
        constants.URLs.customProviders + provider.id + "/uploads/",
        true
      )
      .then((res) => {
        this.showLoader = false;
        this.uploads = res.results || res;
        this.uploadsModal.open();
      })
      .catch((e) => this.handleError(e));
  }

  // --- Helpers ---

  private handleError(error: any) {
    this.showLoader = false;
    let errorMsg;
    try {
      errorMsg = error.json().error_msg || constants.messages.serverError;
    } catch (e) {
      errorMsg = error.message ? error.message : constants.messages.serverError;
    }
    this.adminService.showErrorToast(errorMsg);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/providers/providers.component.ts